import { AppDispatch } from '@store/index';
import { notification } from 'antd';
import Axios from '../../../axios/axios';
import { AxiosError } from 'axios';

export const deleteManager =
    (
        userId: number,
        email: string,
        name: string,
        lastName: string,
        photo: string,
        phoneNumber: string,
        franchiseId: number,
        isActive: number,
        companyId: number,
    ) =>
    async (dispatch: AppDispatch) => {
        dispatch({
            type: 'LOADING_UPDATE_MANAGER',
            payload: true,
        });

        try {
            await Axios.put('/users', {
                userId,
                email,
                name,
                lastName,
                photo,
                phone: phoneNumber,
                franchiseId,
                isActive,
                workPosition: 'manager',
                companyId,
            });
            notification.success({
                message: 'Supervisor eliminado',
                description: '¡El supervisor fue eliminado correctamente!',
            });
        } catch (error) {
            const err = error as AxiosError;
            console.log(err.response?.data);

            notification.error({
                message: 'Ocurrio un error.',
                description: '¡No se pudo eliminado el supervisor!',
            });
        } finally {
            dispatch({
                type: 'LOADING_UPDATE_MANAGER',
                payload: false,
            });
        }
    };
